<template>
    <div  class="form-page">
        <my-form v-model="form" readonly table>
            <my-form-item-group title="查看中标结果通知书">
                <el-form-item label="标段名称" prop="bdname" class="table-full-row">
                    {{form.bdname||'-'}}
                </el-form-item>
                <el-form-item label="通知书编号" prop="tzscode" class="table-full-row">
                    {{form.tzscode||'-'}}
                </el-form-item>
                <el-form-item label="通知书类型" prop="typename" class="table-full-row">
                    {{form.typename||'-'}}
                </el-form-item>
                <el-form-item label="中标人/未中标人" prop="tzscode" class="table-full-row">
                    {{form.zbdwname}}
                </el-form-item>
                <el-form-item label="报价类型" prop="bjlx" class="table-full-row">
                    <div v-if="form.bjlx==='2'">费率/比率/优惠率/合格率等</div>
                    <div v-if="form.bjlx==='3'">单价</div>
                    <div v-if="form.bjlx==='4'">其他形式</div>
                    <div v-if="form.bjlx==='1'||form.bjlx===''">金额</div>
                </el-form-item>
                <el-form-item label="中标/投标价格" prop="yccontent" class="table-full-row">
                    <template v-if="type=='zc'||type=='xt'">
                        <div v-if="form.bjlx=='1'||form.bjlx==''">
                            {{form.zbjg}}{{form.jgdwname}}{{form.bzname}}                       
                        </div>
                        <div v-else>
                            {{form.zbbj}}
                        </div>
                    </template>
                    <template v-if="type=='common'">
                        <div v-if="form.bjlx==='1'">
                            {{form.zbjg}}{{form.jgdwname}}{{form.bzname}}                       
                        </div>
                        <div v-else>
                            {{form.zbbj}}
                        </div>
                    </template>
                   
                </el-form-item>
                <el-form-item label="通知书文本" prop="tzscontent"  class="table-full-row">
                   <div v-html="form.tzscontent"></div>
                </el-form-item>
                <el-form-item label="附件" class="table-full-row">
                    <my-upload readonly  :file-guid="form.fileguid"></my-upload>
                </el-form-item>
            </my-form-item-group>
        </my-form>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {
        return{
            form:{},
            type:''
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {


    },
    created() {
        this.type = this.getQuery('type')
    },
    mounted() {
        var that=this;
        if(this.$route.query.tzscode!=undefined){
            that.$get(`${this.getGetters('bidUrl')}/DingBiao/ZbJgTzs/xingtai/show.json`,{tzscode:this.$route.query.tzscode}, (data, res) => {
                that.form=data.model;
            });
        }
    }
}
</script>

<style scoped lang="scss">

</style>
